import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=67e68a45&"
import script from "./AccountSetting.vue?vue&type=script&lang=js&"
export * from "./AccountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e68a45')) {
      api.createRecord('67e68a45', component.options)
    } else {
      api.reload('67e68a45', component.options)
    }
    module.hot.accept("./AccountSetting.vue?vue&type=template&id=67e68a45&", function () {
      api.rerender('67e68a45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSetting.vue"
export default component.exports